import { useState } from 'react';
import { useDispatch,useSelector } from "react-redux";
import { generatePublicApiToken, selector as generateTokenSelector, TokenExpiryOption } from "./createPublicTokenSlice";
import { getCookie } from '../../common/utils';;
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from '@reduxjs/toolkit';
import { listPublicApiTokens } from '../../pages/integrations/flashcast/listPublicApiTokenSlice';
import { useSpinner } from '../../customHooks';
import useNotification from '../notification/useNotification';
export const useCreatePublicToken = () => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showGeneratedModal, setShowGeneratedModal] = useState(false);
  const [tokenName, setTokenName] = useState("");
  const [tokenExpiry, setTokenExpiry] = useState<TokenExpiryOption | "">("");
  const [generatedToken, setGeneratedToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const generateTokenResponse = useSelector(generateTokenSelector);
  const {showSuccessNotification, showWarningNotification} = useNotification();
  useSpinner(generateTokenResponse.status);

  const handleOpenCreateModal = () => {
    setTokenName("");
    setTokenExpiry("");
    setShowCreateModal(true);
  };

  const handleCloseCreateModal = () => setShowCreateModal(false);
  const handleCloseGeneratedModal = () => {
    dispatch(listPublicApiTokens());
    setShowGeneratedModal(false)
  };

  const handleCreateToken = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!tokenExpiry) {
      showWarningNotification("Please select token expiry");
      return;
    }
    setIsLoading(true);
    const orgId = getCookie('organizationId');
    const email = decodeURIComponent(getCookie('email'));
    const groupId = getCookie('groupId');
    try {
      const payload = {
        tokenName,
        orgId,
        email,
        groupId,
        expiresAt: tokenExpiry,
      };
      const response = await dispatch(generatePublicApiToken(payload)).unwrap();
      setGeneratedToken(response.message.token);
      setShowCreateModal(false);
      setShowGeneratedModal(true);
    } catch (error) {
      console.error("Error generating token:", error);
    }
    finally {
      setIsLoading(false);
  }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedToken);
    showSuccessNotification("Token copied to clipboard");
  };


  return {
    showCreateModal,
    showGeneratedModal,
    tokenName,
    setTokenName,
    tokenExpiry,
    setTokenExpiry,
    generatedToken,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleCloseGeneratedModal,
    handleCreateToken,
    handleCopy,
    isLoading
  };
}